import config from '../config'
import CoreServices from './coreServices'
import { HISTORY } from '../constants/services'
import axios from 'axios'

class HistoryServices extends CoreServices {
  async getConversations(queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/conversations`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        params: queries,
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async getConversation(token) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/conversations/${token}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async getConversationByModelUid(uid) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/conversations/${uid}/uid`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async getSupportConversation() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/conversations/support`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async searchConversation(uid) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/conversations/search?uid=${uid}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new HistoryServices(HISTORY.BASE)
